import { padStart } from 'lodash';


export function parseTimestamp(sec) {
    const int = parseInt(sec, 10) || 0;
    const minutes = Math.floor(int / 60);
    const arr = [padStart(minutes, 2, '0')];
    const hours = Math.floor(minutes / 60);
    if (hours) arr.unshift(padStart(hours, 2, '0'));
    const seconds = int % 60;
    arr.push(padStart(seconds, 2, '0'));
    return arr.join(':');
}



// WEBPACK FOOTER //
// ./src/common/utils/datetime-utils.js